import React, {useEffect, useState} from 'react'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'
import {S3Client, HeadBucketCommand} from '@aws-sdk/client-s3'

const StoragePlugin = () => {
  const [configID, setConfigId] = useState(0)
  const [config, setConfig] = useState<any>({
    storage_type: 'local',
    aws_cdn_url: '',
    aws_endpoint: '',
    aws_region: '',
    aws_access_key: '',
    aws_secret_key: '',
    aws_bucket_name: '',
  })
  const [isTesting, setIsTesting] = useState(false)

  useEffect(() => {
    getConfiguration()
  }, [])

  const handleChange = (event: any) => {
    let name = event.target.name
    let value = event.target.value

    setConfig({...config, [name]: value})
  }

  const onBlurUpdate = () => {
    updateConfiguration(config)
  }

  const getConfiguration = async () => {
    let result = await getConfigurationByName('storage-setting')

    if (result.success) {
      result = result.data
      let parsedData = JSON.parse(result.values)

      setConfigId(result.id)
      setConfig({
        storage_type: parsedData?.storage_type,
        aws_cdn_url: parsedData?.aws_cdn_url,
        aws_endpoint: parsedData?.aws_endpoint,
        aws_region: parsedData?.aws_region,
        aws_access_key: parsedData?.aws_access_key,
        aws_secret_key: parsedData?.aws_secret_key,
        aws_bucket_name: parsedData?.aws_bucket_name,
      })

      let URL = ''
      if (parsedData?.storage_type === 'local') {
        URL = process.env.REACT_APP_SERVER_URL || ''
      } else if (parsedData?.storage_type === 'aws') {
        URL = parsedData?.aws_cdn_url
      }

      localStorage.setItem('baseUrl', URL)
    }
  }

  const updateConfiguration = async (config: any) => {
    let result = await updateConfigurationByConfigID(configID, config, null)
    if (result.success) {
      getConfiguration()
      ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  const testConnection = async () => {
    let config1 = {
      aws_endpoint: config?.aws_endpoint,
      aws_region: config?.aws_region,
      aws_access_key: config?.aws_access_key,
      aws_secret_key: config?.aws_secret_key,
      aws_bucket_name: config?.aws_bucket_name,
    }

    if (Object.values(config1).some((value: any) => !value?.trim())) {
      return ToastUtils({type: 'error', message: 'Fill All Details'})
    }
    setIsTesting(true)

    let s3Client = new S3Client({
      region: config.aws_region,
      credentials: {
        accessKeyId: config.aws_access_key,
        secretAccessKey: config.aws_secret_key,
      },
    })

    try {
      await s3Client.send(new HeadBucketCommand({Bucket: config?.aws_bucket_name}))
      ToastUtils({type: 'success', message: 'Aws Connection is working successfully'})
      setIsTesting(false)
    } catch (error: any) {
      console.log('error', error)
      ToastUtils({type: 'error', message: `Connection failed: ${error.message}`})
      setIsTesting(false)
    }
  }

  return (
    <div className='card'>
      <div className='card-body'>
        <p>
          <strong className='required text-danger'>
            If you change the storage type, you must manually move your upload folder from the
            source to the destination.
          </strong>
        </p>
        <div className='row no-gutters'>
          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Storage Type</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <select
                className='form-select form-select-solid fw-bolder'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                defaultValue={config.storage_type}
                name='storage_type'
                value={config.storage_type}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              >
                <option value={'local'}>Local</option>
                <option value={'aws'}>AWS</option>
              </select>
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>AWS EndPoint</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
            <div className='flex'>
              <input
                type='text'
                className='form-control'
                name='aws_endpoint'
                value={config.aws_endpoint}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>AWS CDN URL</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
            <div className='flex'>
              <input
                type='text'
                className='form-control'
                name='aws_cdn_url'
                value={config.aws_cdn_url}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>AWS Region</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
            <div className='flex'>
              <input
                type='text'
                className='form-control'
                name='aws_region'
                value={config.aws_region}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>AWS Access Key</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
            <div className='flex'>
              <input
                type='text'
                className='form-control'
                name='aws_access_key'
                value={config.aws_access_key}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>AWS Secret Key</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
            <div className='flex'>
              <input
                type='text'
                className='form-control'
                name='aws_secret_key'
                value={config.aws_secret_key}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>AWS Bucket Name</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body align-items-center bg-white'>
            <div className='flex'>
              <input
                type='text'
                className='form-control'
                name='aws_bucket_name'
                value={config.aws_bucket_name}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'></div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <button
              className='btn btn-primary'
              onClick={() => {
                testConnection()
              }}
              disabled={isTesting}
            >
              Test Aws Connection
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StoragePlugin
